module.exports = __webpack_public_path__ + "img/maison-collines.c853d597.webp";